export default {
  language_selector: {
    label: 'Scegli una lingua',
  },
  nav_items: {
    home: 'Home',
    menu: 'Menu',
    locations: 'Sedi',
    store_info: 'Info negozio',
    rewards: 'Premi',
  },
};
